import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function RegisterPage() {
  const { register } = useAuth();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    phone: '',
    address: '',
    postal_code: '',
    city: '',
    isBusiness: false,
    orgNumber: '',
  });

  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const role = await register(formData);
      navigate(role === 'admin' ? '/admin' : '/');
    } catch (err) {
      setError(err.message || 'Noe gikk galt under registrering');
    }
  };

  return (
    <div className="max-w-md mx-auto mt-20 bg-white p-8 rounded-lg shadow-lg">
      <h1 className="text-2xl font-bold text-center text-[#000099] mb-6">
        Registrer deg
      </h1>
      {error && <p className="text-red-500 text-sm mb-4">{error}</p>}
      <form onSubmit={handleSubmit} className="space-y-4">
        <input
          name="name"
          type="text"
          placeholder="Navn"
          value={formData.name}
          onChange={handleChange}
          required
          className="w-full border border-gray-300 rounded px-3 py-2"
        />
        <input
          name="email"
          type="email"
          placeholder="E-post"
          value={formData.email}
          onChange={handleChange}
          required
          autoComplete="email"
          className="w-full border border-gray-300 rounded px-3 py-2"
        />
        <input
          name="password"
          type="password"
          placeholder="Passord"
          value={formData.password}
          onChange={handleChange}
          required
          autoComplete="new-password"
          className="w-full border border-gray-300 rounded px-3 py-2"
        />
        <input
          name="phone"
          type="tel"
          placeholder="Telefon (valgfritt)"
          value={formData.phone}
          onChange={handleChange}
          className="w-full border border-gray-300 rounded px-3 py-2"
        />
        <input
          name="address"
          type="text"
          placeholder="Adresse (valgfritt)"
          value={formData.address}
          onChange={handleChange}
          className="w-full border border-gray-300 rounded px-3 py-2"
        />

        <div className="grid grid-cols-2 gap-3">
          <input
            name="postal_code"
            type="text"
            placeholder="Postnr (4 siffer)"
            value={formData.postal_code}
            onChange={handleChange}
            pattern="\d{4}"
            title="Postnummer må være 4 siffer"
            className="w-full border border-gray-300 rounded px-3 py-2"
          />
          <input
            name="city"
            type="text"
            placeholder="Sted"
            value={formData.city}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded px-3 py-2"
          />
        </div>

        <div className="flex items-center gap-3">
          <label className="font-medium">
            <input
              type="checkbox"
              name="isBusiness"
              checked={formData.isBusiness}
              onChange={handleChange}
              className="mr-2"
            />
            Jeg registrerer meg som bedrift
          </label>
        </div>
        {formData.isBusiness && (
          <input
            name="orgNumber"
            type="text"
            placeholder="Organisasjonsnummer"
            value={formData.orgNumber}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded px-3 py-2"
            required
          />
        )}
        <button
          type="submit"
          className="w-full bg-[#000099] text-white font-semibold py-2 px-4 rounded hover:bg-blue-800 transition-colors"
        >
          Registrer
        </button>
      </form>
    </div>
  );
}

export default RegisterPage;
